"use strict";
var root_1 = require("./root");
var MapPolyfill_1 = require("./MapPolyfill");
exports.Map = root_1.root.Map || (function () { return MapPolyfill_1.MapPolyfill; })();
//# sourceMappingURL=Map.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/rxjs/util/Map.js
 ** module id = 320
 ** module chunks = 1
 **/